export const SentryIgnore = [
  'AjaxError',
  'ajax error',
  /.*"0x80004005 \(NS_ERROR_FAILURE\)".*/ /* Mozilla special error */,
];
